export function normalizeRoleCode(roleCode?: string | null): string {
  return (roleCode || '').trim().toLowerCase();
}

export function isDoctorRoleCode(roleCode?: string | null): boolean {
  const normalized = normalizeRoleCode(roleCode);
  return normalized === 'doctor' || normalized === 'medico';
}
